'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice(id, gpId, drugRequestId, pharmacyId) {
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_gpId = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_drugRequestId = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_pharmacyId = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id = id;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_gpId = gpId;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_drugRequestId = drugRequestId;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_pharmacyId = pharmacyId;
}
export { $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice as $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice };
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.constructor = $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice;
/** @constructor */
function $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice() {
}
export { $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice as $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice };
$h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype = $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype;
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1260680601), true);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice)) {
    var x = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id;
    var x$2 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_gpId;
      var x$4 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_gpId;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_drugRequestId;
      var x$6 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_drugRequestId;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_pharmacyId;
      var x$8 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_pharmacyId;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.productArity__I = (function() {
  return 4;
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.productPrefix__T = (function() {
  return "ChatsReadOfDrugRequestForGeneralPractice";
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id;
      break;
    }
    case 1: {
      return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_gpId;
      break;
    }
    case 2: {
      return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_drugRequestId;
      break;
    }
    case 3: {
      return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_pharmacyId;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "gpId";
      break;
    }
    case 2: {
      return "drugRequestId";
      break;
    }
    case 3: {
      return "pharmacyId";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice.prototype.id__Ljkugiya_ulid_ULID = (function() {
  return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice__f_id;
});
function $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice)));
}
export { $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice as $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice };
var $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice, "app.pages.AppPage$ChatsReadOfDrugRequestForGeneralPractice", ({
  Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice: 1,
  Lapp_pages_AppPage: 1,
  Lapp_pages_AppPage$HasChatId: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice as $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForGeneralPractice };
//# sourceMappingURL=app.pages.-App-Page$-Chats-Read-Of-Drug-Request-For-General-Practice.js.map
